import { useEffect, useRef, useState } from "react";
import { spanishViridian500 } from "@habitech/shared";
import Icon from "src/components/common/Icon";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectSelectedPaymentMethod } from "src/redux/shopping_cart/shopping_cart.selectors";
import { setSelectedPaymentMethod } from "src/redux/shopping_cart/shopping_cart.slice";
import {
    Card,
    DropdownList,
    DropdownWrapper,
    Header,
    Label,
    Option,
    Trigger,
} from "./PaymentMethodSelect.styles";
import { methodsName, payment_method, pyament_method_str } from "src/constants/ShoppingCart";

/** value = número que se envía al endpoint como Payment-Method */
const PAYMENT_OPTIONS = [
    { value: payment_method[methodsName.CARD], label: pyament_method_str[methodsName.CARD] },
    { value: payment_method[methodsName.TRANSFER], label: pyament_method_str[methodsName.TRANSFER] },
    { value: payment_method[methodsName.CASH], label: pyament_method_str[methodsName.CASH] },
    // { value: payment_method[methodsName.PAYPAL], label: pyament_method_str[methodsName.PAYPAL] },
] as const;

const PLACEHOLDER = "Selecciona un método de pago";

const PaymentMethodSelect = () => {
    const dispatch = useAppDispatch();
    const selectedValue = useAppSelector(selectSelectedPaymentMethod);
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const selectedOption = selectedValue !== null
        ? PAYMENT_OPTIONS.find((o) => o.value === selectedValue)
        : null;
    const displayLabel = selectedOption ? selectedOption.label : PLACEHOLDER;
    const isPlaceholder = selectedValue === null;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    return (
        <Card ref={containerRef}>
            <Header>
                <Icon icon="pcom-icon-credit-card-2" size={22} style={{ color: spanishViridian500 }} />
                <h2 className="header-title">Método de Pago</h2>
            </Header>
            <Label htmlFor="payment-method-trigger">Forma de pago</Label>
            <DropdownWrapper>
                <Trigger
                    id="payment-method-trigger"
                    type="button"
                    className={isPlaceholder ? "placeholder" : ""}
                    onClick={() => setIsOpen((prev) => !prev)}
                    aria-haspopup="listbox"
                    aria-expanded={isOpen}
                >
                    <span>{displayLabel}</span>
                    <Icon
                        icon="pcom-icon-chevron-down"
                        size={16}
                        style={{ transform: isOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s ease" }}
                    />
                </Trigger>
                {isOpen && (
                    <DropdownList role="listbox">
                        {PAYMENT_OPTIONS.map((option) => (
                            <Option
                                key={option.value}
                                role="option"
                                aria-selected={selectedValue === option.value}
                                $selected={selectedValue === option.value}
                                onClick={() => {
                                    dispatch(setSelectedPaymentMethod(option.value));
                                    setIsOpen(false);
                                }}
                            >
                                {option.label}
                            </Option>
                        ))}
                    </DropdownList>
                )}
            </DropdownWrapper>
        </Card>
    );
};

export default PaymentMethodSelect;
